import { useCallback, useState } from "react";

import { useAuth } from "shared/contexts/Auth/AuthContext";

import { ICompra } from "shared/interfaces/ICompra";

import {
  buscarComprasPorUsuario,
  buscarMinhasAvaliacoes,
} from "shared/services/api/compras.api";

export function useCompras() {
  const { user, loadingAuth } = useAuth();

  const [compras, setCompras] = useState<ICompra[]>([]);
  const [loading, setLoading] = useState(false);

  const carregarCompras = useCallback(async () => {
    if (loadingAuth) {
      return;
    }

    if (!user?.uid) {
      setCompras([]);
      return;
    }

    setLoading(true);

    try {
      /* =================================
         BUSCAR COMPRAS E AVALIAÇÕES
      ================================= */

      const [comprasData, avaliacoesData] =
        await Promise.all([
          buscarComprasPorUsuario(),
          buscarMinhasAvaliacoes(),
        ]);

      console.log(
        "COMPRAS RECEBIDAS:",
        comprasData
      );

      console.log(
        "AVALIAÇÕES RECEBIDAS:",
        avaliacoesData
      );

      /* =================================
         VINCULAR AVALIAÇÃO À COMPRA
      ================================= */

      const comprasComAvaliacao = comprasData.map(
        (compra) => {
          const avaliacao = avaliacoesData.find(
            (item) =>
              item.orderId === compra.id
          );

          if (avaliacao) {
            console.log(
              `Compra ${compra.id} já foi avaliada:`,
              avaliacao
            );

            return {
              ...compra,

              avaliacao: avaliacao.rating,

              comentario:
                avaliacao.comment ?? "",
            };
          }

          console.log(
            `Compra ${compra.id} ainda não foi avaliada`
          );

          return {
            ...compra,

            avaliacao: undefined,

            comentario: undefined,
          };
        }
      );

      console.log(
        "COMPRAS COM AVALIAÇÕES:",
        comprasComAvaliacao
      );

      setCompras(comprasComAvaliacao);
    } catch (error) {
      console.error(
        "Erro ao buscar compras e avaliações:",
        error
      );

      setCompras([]);
    } finally {
      setLoading(false);
    }
  }, [user?.uid, loadingAuth]);

  return {
    compras,

    loading: loading || loadingAuth,

    vazio:
      !loading &&
      compras.length === 0,

    carregarCompras,
  };
}